export const categoryDetails = [
    {
        id: 1,
        default: require('@/assets/眼眉/2_1.jpg'),
        active: require('@/assets/眼眉/2_1.jpg'),
        describe1: '极细眼线笔「小花笔」',
        describe2: '勾勒你的专属眼色',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.48.6118e061yNCaEe&id=576073283354&rn=8ac95eb151fc2846c4953480be7e6d03&abbucket=17'
    },
    {
        id: 2,
        default: require('@/assets/眼眉/2_2.jpg'),
        active: require('@/assets/眼眉/2_2.jpg'),
        describe1: '丝柔防水眼线胶笔',
        describe2: '流畅勾画 点亮双眸',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.53.6118e061yNCaEe&id=575711942872&rn=8ac95eb151fc2846c4953480be7e6d03&abbucket=17'
    },
    {
        id: 3,
        default: require('@/assets/眼眉/2_3.jpg'),
        active: require('@/assets/眼眉/2_3.jpg'),
        describe1: '卧蚕笔家族',
        describe2: '一笔大眼 卧蚕无中生有',
        links: 'https://detail.tmall.com/item.htm?app=chrome&bxsign=scdIBqSjHyUnEs6B9OhOBLyxbyGIQM4K-a9MkZiBpSjXB2kiVHrQnV3V9fxfrDDMQ-jZOMQs7JQjH1tj_100SIyzTghTb4TsyDCcKjCLR-hhKy2qdn86iQsIY1YVZfVqhrp&cpp=1&id=583964792445&origin_price=49-59&price=29.8-39.8&shareUniqueId=19939291162&share_crt_v=1&shareurl=true&short_name=h.UNxzRum&sourceType=item&sp_abtk=gray_1_code_simpleios2&sp_tk=cGpSSmQ2a0hrWGE=&spm=a2159r.13376460.0.0&suid=257607A3-ACCD-4890-9696-F73D65AA6ADC&tbSocialPopKey=shareItem&tk=pjRJd6kHkXa&un=26037f64cf4c5ce5b2a02c4eb1ea31ed&un_site=0&ut_sk=1.X97pKKL5aq8DAOKGXjarDDr1_21380790_1675753324599.Copy.1'
    }
]